// src/data/items/glyphCores.js
// Glyph Cores crafted in Glyphbinding, combined with logs in Woodworking to create staffs

/**
 * Glyph Cores - magical orbs/crystals that attach to wooden staves
 * Crafted from glyphs in Glyphbinding skill
 * 7 tiers matching the wood types
 */
export const GLYPH_CORES = [
    {
        id: 'common_glyph_core',
        name: 'Common Glyph Core',
        color: '#DEB887',
        value: 150,
        tier: 1
    },
    {
        id: 'ironwood_glyph_core',
        name: 'Ironwood Glyph Core',
        color: '#A0522D',
        value: 350,
        tier: 2
    },
    {
        id: 'softbark_glyph_core',
        name: 'Softbark Glyph Core',
        color: '#6B8E23',
        value: 600,
        tier: 3
    },
    {
        id: 'goldleaf_glyph_core',
        name: 'Goldleaf Glyph Core',
        color: '#D2691E',
        value: 950,
        tier: 4
    },
    {
        id: 'redgrain_glyph_core',
        name: 'Redgrain Glyph Core',
        color: '#CD853F',
        value: 1400,
        tier: 5
    },
    {
        id: 'gravewood_glyph_core',
        name: 'Gravewood Glyph Core',
        color: '#228B22',
        value: 2000,
        tier: 6
    },
    {
        id: 'arcanewood_glyph_core',
        name: 'Arcanewood Glyph Core',
        color: '#9370DB',
        value: 3200,
        tier: 7
    }
];

export default GLYPH_CORES;
